import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthPageShell from '@components/layout/AuthPageShell';
import AuthFormCard from '@components/layout/AuthFormCard';
import FamilyOnboardingForm from '@components/profile/FamilyOnboardingForm';
import { useAuthStore } from '@store/authStore';
import { getFamilySetupNextPath, resolvePostLoginDestination } from '@utils/authRouting';
import { isSafeAppReturnUrl } from '@utils/safeReturnUrl';

const FamilyOnboardingPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuthStore();
  const returnUrl = searchParams.get('returnUrl');

  const homeDestination = useMemo(
    () => resolvePostLoginDestination(user, isSafeAppReturnUrl(returnUrl) ? returnUrl : null),
    [user, returnUrl],
  );

  useEffect(() => {
    if (!user) return;
    if (user.isChildInCustody) {
      navigate(homeDestination, { replace: true });
      return;
    }
    if (!user.needsFamilyOnboarding && user.maritalStatus) {
      navigate(getFamilySetupNextPath(user), { replace: true });
    }
  }, [user, homeDestination, navigate]);

  return (
    <AuthPageShell>
      <AuthFormCard
        roleLabel="Account"
        title="Your family status"
        subtitle="Set this once. Add a child later only if you are married and have saved your relation."
        chrome
      >
        <FamilyOnboardingForm
          onSaved={(saved) => navigate(getFamilySetupNextPath(saved), { replace: true })}
        />
      </AuthFormCard>
    </AuthPageShell>
  );
};

export default FamilyOnboardingPage;
